




































































import { Component, Prop, Emit } from 'vue-property-decorator'

import { dateTimeToDisplay, dateToDisplay, dateToNow } from '@/utils/dateTime'
import FoldingCard from '@/components/FoldingCard.vue'
import { mixins } from 'vue-class-component'
import { Case } from '@/modules/Newcase/interfaces/case'
import AccountAssets from '@/modules/Newcase/components/AccountAssets.vue'
import AccountCertificates from '@/modules/Newcase/components/AccountCertificates.vue'
import CaseAttachmentsCard from '../components/CaseAttachmentCard.vue'
import AccountInfo from '@/modules/Newcase/components/AccountInfo.vue'
import CasePolicyInfo from '../components/CasePolicyInfo.vue'
import CasePolicyDocusign from '../components/CasePolicyDocusign.vue'
import CaseFoldingCard from '@/modules/Newcase/components/CaseFoldingCard.vue'
import { Task, TaskRelatedCell, TaskStatus } from '@/modules/Task/interfaces/task'
import { ApolloResponse } from '@/interfaces/apollo'
import { getTask, commentToTask, completeTask } from '@/modules/Task/gql/task.gql'
import { showErrors, showNotification } from '@/utils/snack'
import { Policy } from '@/modules/Policy/interfaces/policy'
import { Account } from '@/modules/Account/interfaces/account'
import { SnackType } from '@/interfaces/snack'
import AppDialog from '@/components/AppDialog.vue'
import AppTextarea from '@/components/AppTextarea.vue'

@Component({
  components: {
    FoldingCard,
    AccountAssets,
    AccountCertificates,
    CaseAttachmentsCard,
    AccountInfo,
    CasePolicyInfo,
    CasePolicyDocusign,
    CaseFoldingCard,
    AppDialog,
    AppTextarea
  }
})
export default class CaseTaskDetailDrawer extends mixins() {
  @Prop({ type: Number }) readonly taskId!: number

  folding = false
  dialogShow = false
  disableConfirm = false

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay
  dateToNow = dateToNow
  TaskStatus = TaskStatus

  taskInfo: Task | null = null

  commentInput = {
    content: ''
  }

  mounted () {
    this.getTaskDetail()
  }

  async getTaskDetail () {
    const { taskId } = this
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getTask,
        variables: {
          taskId
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      const relations: TaskRelatedCell[] = []
      if (result.data.getTask.cases) {
        this.$R.forEach((item: Case) => {
          const cell: TaskRelatedCell = {
            type: 'CASE',
            cell: {
              id: +item.id,
              name: item.inquiryName
            }
          }
          relations.push(cell)
        }, result.data.getTask.cases)
      }
      if (result.data.getTask.policies) {
        this.$R.forEach((item: Policy) => {
          const cell: TaskRelatedCell = {
            type: 'POLICY',
            cell: {
              id: +item.id,
              name: item.policyName
            }
          }
          relations.push(cell)
        }, result.data.getTask.policies)
      }
      if (result.data.getTask.accounts) {
        this.$R.forEach((item: Account) => {
          const cell: TaskRelatedCell = {
            type: 'ACCOUNT',
            cell: {
              id: +item.id,
              name: item.name
            }
          }
          relations.push(cell)
        }, result.data.getTask.accounts)
      }
      result.data.getTask.relations = relations.concat()
      this.taskInfo = result.data.getTask
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async newComment () {
    const { taskId, commentInput } = this
    const { content } = commentInput
    if (!content) {
      return
    }
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: commentToTask,
        variables: {
          taskId,
          content
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.commentInput = {
        content: ''
      }
      this.getTaskDetail()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  closingHandler () {
    this.folding = true
    setTimeout(() => {
      this.onClose()
    }, 500)
  }

  generateAssignTo (item: Task) {
    const { assignedTo } = item

    return assignedTo.reduce((prev, curr, currIdx) => {
      if (currIdx === assignedTo.length - 1) {
        return prev + curr.username
      } else {
        return prev + curr.username + ', '
      }
    }, '')
  }

  generateComment (comment: string) {
    return comment.split('\n')
  }

  dialogConfirm () {
    this.dialogShow = false
    this.completeTaskConfirm()
  }

  async completeTaskConfirm () {
    const { taskId } = this
    try {
      const result = await this.$apollo.mutate({
        mutation: completeTask,
        variables: {
          taskId
        }
      })
      const res = result.data.completeTask
      if (!res) {
        return
      }
      showNotification({
        msg: 'Task complete successfully',
        type: SnackType.Success
      })

      this.getTaskDetail()
      this.onComplete()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  hideActionDialog () {
    this.dialogShow = false
  }

  @Emit('close')
  onClose () {
    // do nothing
  }

  @Emit('complete')
  onComplete () {
    // do nothing
  }
}
